import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Selfparal.css'
import './Selfparal1.css'
import './Selfscroll.css'
import '../brandselfauditkit/SelfBybToolkit/BybToolkit.css'
import "../brandselfauditkit/SelfOverlayVideoSection.css";
import "../brandselfauditkit/SelfBybChecklist/BybChecklist.css";
import VideoModal from "../brandselfauditkit/SelfVideoModal";
import PlayButton from "../brandselfauditkit/SelfPlayButton";
import { Helmet } from 'react-helmet';
function SelfParal() {
  const panelsRef = useRef([]);
 const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  const openModal = () => {
    setModal(!modal);
  };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };

  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    let panels = panelsRef.current;
    let tops = panels.map(panel => ScrollTrigger.create({ trigger: panel, start: "top top" }));

    panels.forEach((panel) => {
      ScrollTrigger.create({
        trigger: panel,
        start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
        pin: true,
        pinSpacing: false
      });
    });

    // ScrollTrigger.create({
    //   snap: {
    //     snapTo: (progress, self) => {
    //       let panelStarts = tops.map(st => st.start());
    //       let snapScroll = gsap.utils.snap(panelStarts, self.scroll());
    //       return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll);
    //     },
    //     duration: 0.5
    //   }
    // });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  const [isOpen, setOpen] = useState(false);

  function handleChange() {
    setOpen(!isOpen);
  }


  
  // const [systemInfo, setSystemInfo] = useState({
  //   platform: "",
  //   userAgent: "",
  //   cpuCores: 0,
  // });

  // useEffect(() => {
  //   const fetchSystemInfo = () => {
  //     const platform = navigator.platform || 'Unknown';
  //     const userAgent = navigator.userAgent || 'Unknown';
  //     const cpuCores = navigator.hardwareConcurrency || 0; // Get number of CPU cores
  //     setSystemInfo({ platform, userAgent, cpuCores });
  //   };

  //   fetchSystemInfo();
  // }, []);

  

  // useEffect(() => {
  //   const detectMacArchitecture = () => {
  //    const check_list =   document.body.querySelector('.check_list');
  //    const bybAnalysis =   document.body.querySelector('.byb-analysis');
  //    const bybAudit =   document.body.querySelector('.byb-audit');
  //    const check_list_believe =   document.body.querySelector('.check_list.byb_believe');
  //    const panel =   document.body.querySelector('.panel.red');
  //    const legacy =   document.body.querySelector(' .legacy-content');
  //    const description_panel =   document.body.querySelector('.description.panel');

    
  //     const body = document.body;
      
  //     const { platform, cpuCores } = systemInfo;

  //     if (platform.includes('Win')) {
  //       // legacy.style.backgroundColor ="brown"
  //       body.style.backgroundColor = 'rgb(7 26 40)'; // Windows
  //       check_list.style.background ="rgb(7 26 40)"
  //       bybAnalysis.style.background ="rgb(7 26 40)"
  //       bybAudit.style.background="rgb(7 26 40)"
  //       check_list_believe.style.background="rgb(7 26 40)"
  //       panel.style.background="rgb(7 26 40)"
  //       legacy.style.background="rgb(7 26 40)"
  //       description_panel.style.background="rgb(7 26 40)"
  //       // check_list_believe
  //     }
  //      else if (platform.includes('Mac'))
  //        {  
  //       if (cpuCores >= 8) {
  //         body.style.backgroundColor = 'hwb(202.33deg 0.78% 82.35%)';
  //         check_list.style.background ="hwb(202.33deg 0.78% 82.35%)"
  //         bybAnalysis.style.background ="hwb(202.33deg 0.78% 82.35%)"
  //         bybAudit.style.background ="hwb(202.33deg 0.78% 82.35%)"// Mac M Series (ARM64)
  //         panel.style.background="hwb(202.33deg 0.78% 82.35%)"
  //         legacy.style.background="hwb(202.33deg 0.78% 82.35%)"
  //         description_panel.style.background="hwb(202.33deg 0.78% 82.35%)"

  //       } else {
  //         body.style.backgroundColor = 'hwb(204.29deg 1.18% 82.35%)'; // Mac Intel
  //         check_list.style.background ="hwb(204.29deg 1.18% 82.35%)"
  //         bybAnalysis.style.background ="hwb(204.29deg 1.18% 82.35%)"
  //         bybAudit.style.background ="hwb(204.29deg 1.18% 82.35%)"
  //         panel.style.background="hwb(204.29deg 1.18% 82.35%)"
  //         legacy.style.background="hwb(204.29deg 1.18% 82.35%)"
  //         description_panel.style.background="hwb(204.29deg 1.18% 82.35%)"


  //       }
  //     } 
   
  //   };

  //   detectMacArchitecture();
  // }, [systemInfo]); 



  return (
    <>

    {/* <Helmet key="brandselfauditkit">
        <title>DIY Brand Self-Audit Toolkit</title>
        <meta name='description' content='Use our comprehensive toolkit to self-audit your brand, align strategy, and ensure consistent identity.'/>
    </Helmet> */}
      <div className="description panel byb-toolkit" ref={el => panelsRef.current[0] = el} id="header_text">
        <div className="legacy-content ">

        <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}> Introducing the Brand Self-Audit Kit</p>
            <h1>
              <span className="d-inline d-lg-block "> Take the First Step Towards Brewing</span>
              Your Brand's Enduring Legacy.
            </h1>
            <p>
              {/* Introducing the Brand Audit Kit —
              <span style={{ color: "white" }}>
                a comprehensive, hands-on toolkit designed to help you evaluate,
                enhance, and brew a purposeful brand.
              </span> With practical tools, detailed guides, and expert insights, it
              empowers you to create a brand that stands the test of time. */}
             A hands-on, comprehensive brand self-auditing toolkit, ​
                that empowers you to evaluate, enhance and brew a purposeful brand. ​
                With practical tools, guides, and expert insights, it empowers you to create a brand that stands the test of time.
            </p>
            <div className="byb-toolkit-img">
              <img
                className="vision-image"
                src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/brandkit.png"
                alt="Brand self-audit toolkit visual"
                style={{ height: "auto", objectFit: "cover" }}
              />
            </div>
        </div>
      </div>
      {/* </div> */}
      <section className="panel red" >
      <div className="panel-overlay ">
          <ul>
            <li className="overlay-text">Be More Than a Name</li>
            <li className="overlay-text">Imagine a brand that's not just recognised but remembered. ​
            A brand that tells a story, sparks conversations, and forges deep connections.</li>
            <li className="overlay-text">A brand that captures your vision and turns it into an experience—one that inspires trust, shapes culture, and creates a ripple effect of impact.</li>
            <li className="overlay-text">This is the essence of brewing your brand—a transformative journey that goes beyond mere branding to build something meaningful, timeless, and truly yours.</li>

      <li className="overlay-text">With the Brand Self-Audit Kit, take your first step towards crafting a brand that matters.</li>
          </ul>

          <VideoModal isOpen={isOpen} close={handleChange} />
          <PlayButton click={handleChange} />
        </div>
      </section>
    </>
  );
}

export default SelfParal;
